<template>
  <div
    ref="chartRef"
    style="width: 1100px; height: 500px;"
  />
</template>

<script setup>
import * as echarts from 'echarts'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'

const props = defineProps({
  xAxisData: {
    type: Array,
    required: true,
  },
  seriesData: {
    type: Array,
    required: true,
  },
  yAxisTitle: {
    type: String,
    default: 'Jumlah Kutipan (RM)',
  },
})

const chartRef = ref(null)
let chartInstance = null

const initChart = () => {
  if (chartInstance) {
    chartInstance.dispose()
  }

  const chartDom = chartRef.value
  if (chartDom) {
    chartInstance = echarts.init(chartDom)

    const option = {
      title: {
        text: props.chartTitle,
        left: 'center',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: props.xAxisData.slice().reverse(),
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            rotate: 0,
            interval: 0,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: props.yAxisTitle,
        },
      ],
      series: [
        {
          name: '',
          type: 'bar',
          barWidth: '30%',
          data: props.seriesData.slice().reverse(),
        },
      ],
    }


    chartInstance.setOption(option)
    window.addEventListener('resize', chartInstance.resize)
  }
}


onMounted(initChart)

onBeforeUnmount(() => {
  if (chartInstance) {
    window.removeEventListener('resize', chartInstance.resize)
    chartInstance.dispose()
  }
})

watch(
  () => [props.xAxisData, props.seriesData],
  initChart,
  { deep: true },
)
</script>

<style scoped>
div[ref="chartRef"] {
  width: 100%;
  height: 500px;
}
</style>
